// app/javascript/controllers/tabs_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values  = { active: String }

  connect() {
    this.showPanel(this.activeValue || this.tabTargets[0]?.dataset.tabsPanel)
  }

  show(event) {
    event.preventDefault()
    this.showPanel(event.currentTarget.dataset.tabsPanel)
  }

  showPanel(selected) {
    // Update tab button styles
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tabsPanel === selected
      if (isActive) {
        tab.classList.add("bg-white", "text-gray-900", "shadow-sm")
        tab.classList.remove("text-gray-500")
      } else {
        tab.classList.remove("bg-white", "text-gray-900", "shadow-sm")
        tab.classList.add("text-gray-500")
      }
    })

    // Show / hide panels
    this.panelTargets.forEach(panel => {
      if (panel.dataset.tabsPanel === selected) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
